export const ROUTES = {
  // Auth
  LOGIN: "/login",
  REGISTER: "/register",
  UNLOCK: "/unlock",
  FORGOT_PASSWORD: "/forgot-password",
  VERIFY_EMAIL: "/verify-email",

  // Main (App - Private)
  DASHBOARD: "/app",
  VAULT: "/app/vault",
  VAULT_DETAIL: (id: string) => `/app/vault/${id}`,

  // Items
  ITEM_NEW: "/app/item/new",
  ITEM_DETAIL: (id: string) => `/app/item/${id}`,

  // Tools
  GENERATOR: "/app/generator",
  SECURITY_REPORT: "/app/security-report",
  TRASH: "/app/trash",
  DOWNLOADS: "/app/downloads",

  // Settings
  SETTINGS: "/app/settings",
  SETTINGS_BILLING: "/app/settings/billing",
  SETTINGS_BILLING_PLANS: "/app/settings/billing/plans",
  SETTINGS_BILLING_PAYMENTS: "/app/settings/billing/payments",
  SETTINGS_BILLING_MANAGE: "/app/settings/billing/manage",
  SETTINGS_SECURITY: "/app/settings/security",
  SETTINGS_SESSIONS: "/app/settings/sessions",
  SETTINGS_IMPORT: "/app/settings/import",
  SETTINGS_EXPORT: "/app/settings/export",
  SETTINGS_FAMILY: "/app/settings/family",
  SETTINGS_EMERGENCY: "/app/settings/emergency-contacts",
  SETTINGS_PASSKEYS: "/app/settings/passkeys",
  SETTINGS_API_TOKENS: "/app/settings/api-tokens",
  SETTINGS_API_DOCS: "/app/settings/api-docs",
  AUTHENTICATOR: "/app/authenticator",
} as const;
